import { requests } from 'legacy/utils/requests'
import sentry from 'legacy/utils/sentry'

const BASE_URL = '/api/v2/loadboard'

/**
 * @typedef {{count: number; next: string | null; previous: string | null; results: Array<T>}} ListResult<T>
 * @template {any} T
 */

/**
 * @param {Partial<import('core/infra/http/HttpClient').HttpClientConfig>} [options]
 * @returns {import('core/infra/http/HttpClient').HttpClientResponse<ListResult<import('loads/infra/offerMapper').RawOffer>>}
 */
export function getOfferList(options = {}) {
  return requests.get(`${BASE_URL}/offers`, options)
}

export function getTopOffers() {
  return requests
    .get(`${BASE_URL}/offers/top`)
    .catch(error => {
      throw error
    })
    .then(response => response.data.results)
}

export function getOfferBids(offerUuid, params) {
  return requests
    .get(`${BASE_URL}/offers/${offerUuid}/bids`, { params })
    .catch(error => {
      sentry.log('[Service::getOfferBids] failed to get offer bids', error)
      return { data: { results: [] } }
    })
    .then(response => response.data.results)
}

export function getOffer(offerUuid, params) {
  return requests.get(`${BASE_URL}/offers/${offerUuid}/`, params)
}
